import type { Observable } from 'rxjs/Observable';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';
import type { BaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';
import type { GetChatAppStatusResponse } from '../../model/types';

const getChatAppStatusUrl = (baseUrl: BaseUrl, addonKey: string) =>
	`${baseUrl}/rest/atlassian-connect/1/addons/${addonKey}`;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: BaseUrl, addonKey: string): Observable<GetChatAppStatusResponse> =>
	fetchJson$(getChatAppStatusUrl(baseUrl, addonKey), {
		method: 'GET',
	});
